import { PayloadAction } from '@reduxjs/toolkit';
import { StockStatusResponse } from './types';
import { initialState } from './index';

export const reducers = {
  getStockStatus(state, action: any) {
    state.isLoading = true;
  },
  getStockStatusSuccess(state, action: PayloadAction<StockStatusResponse>) {
    state.isLoading = false;
    state.error = null;
    state.data = action.payload;
  },
  getStockStatusFail(state, action: PayloadAction<unknown>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
